import PropTypes from 'prop-types'

const hydratedRecipePropType = PropTypes.object

export default hydratedRecipePropType
